// extracted by mini-css-extract-plugin
export default {"lateFeeSupportArticleLink":"U1GQZQflgA8hnEOjx0mD","pulse":"ZOhwd4wUFcnvDO8ZNW1J"};